<template>
    <div>
        <div class="auth-header">
            <div class="logo">
                <img src="../../assets/images/logo.svg" alt="Biopharama Investing">
            </div>
        </div>
        <div class="authentication-page">
            <Login></Login>
        </div>
    </div>
</template>

<script>

import Login from '../Authentication/LoginComponent.vue';

export default {
    components: {
        Login,
    },
};

</script>

<style lang="scss">
    @import '../../style/layout/AuthenticationPage.scss';
</style>
